import { Skeleton } from "@repo/design-system";

export function VisualAnalysisSkeleton() {
  return (
    <div className="min-h-[calc(100vh-6rem)] bg-backgroundPrimary p-8">
      <div className="mx-auto max-w-7xl">
        <div className="mb-8">
          <Skeleton className="h-9 w-56 rounded-lg" />
        </div>
        <div className="grid grid-cols-2 gap-4 xl:grid-cols-4">
          {Array.from({ length: 8 }).map((_, i) => (
            <div
              key={i}
              className="flex flex-col gap-3 rounded-xl border border-borderPrimary bg-backgroundPrimary p-4">
              <Skeleton className="h-4 w-44 rounded" />
              <Skeleton className="h-52 w-full rounded-lg" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
